var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMeshIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 16 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: none;\n      }\n\n      .cls-2 {\n        fill: url(#linear-gradient);\n      }\n\n      .cls-3 {\n        fill: #001d6c;\n      }\n\n      .cls-4 {\n        fill: url(#linear-gradient-2);\n      }\n\n      .cls-5 {\n        fill: #fff;\n        opacity: 0;\n      }\n    "), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x1: 4.5,
    y1: -116.62,
    x2: 4.5,
    y2: -122.62,
    gradientTransform: "translate(0 -107.63) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#161616",
    stopOpacity: 0.4
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#161616",
    stopOpacity: 0.05
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: 4.82,
    y1: -121.3,
    x2: 11.18,
    y2: -114.94,
    gradientTransform: "translate(0 -107.63) scale(1 -1)",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.1,
    stopColor: "#08bbb8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9,
    stopColor: "#0f62fc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-5",
    width: 16,
    height: 16
  }), /*#__PURE__*/React.createElement("g", {
    id: "Light_theme_icons",
    "data-name": "Light theme icons"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 8,
    cy: 2.51,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 3.01,
    cy: 5.01,
    r: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-3",
    cx: 12.99,
    cy: 5.01,
    r: 1.5
  })), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M4,8.99c-1.65,0-3,1.35-3,3s1.35,3,3,3h4v-6H4Z"
  }), /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 8,
    cy: 10.49,
    r: 4.5
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M12.5,9.99h-4.5c-1.38,0-2.5,1.12-2.5,2.5s1.12,2.5,2.5,2.5h4.5c1.38,0,2.5-1.12,2.5-2.5s-1.12-2.5-2.5-2.5Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    x: 0,
    width: 16,
    height: 16
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeshIcon);
export default __webpack_public_path__ + "static/media/meshIcon.59263220ee0d5e145deab612129c5794.svg";
export { ForwardRef as ReactComponent };